import { render, staticRenderFns } from "./table-header.vue?vue&type=template&id=2d6fd5ec&scoped=true&"
import script from "./table-header.vue?vue&type=script&lang=ts&"
export * from "./table-header.vue?vue&type=script&lang=ts&"
import style0 from "./table-header.vue?vue&type=style&index=0&id=2d6fd5ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6fd5ec",
  null
  
)

export default component.exports